<nz-skeleton [nzActive]="true" *ngIf="isLoading"></nz-skeleton>
<!-- <nz-skeleton [nzActive]="true" *ngIf="isLoading"></nz-skeleton>
<nz-skeleton [nzActive]="true" *ngIf="isLoading"></nz-skeleton> -->

<div class="categories-section" *ngIf="!isLoading">
  <ng-container *ngFor="let cat of categories">
    <ng-container
      [ngTemplateOutlet]="catWrapper"
      [ngTemplateOutletContext]="{ category: cat }"
    >
    </ng-container>
  </ng-container>
</div>

<ng-template #catWrapper let-category="category">
  <ng-container *ngIf="category.childCategories.length > 0">
    <nz-collapse nzGhost>
      <nz-collapse-panel
        [nzActive]="expandedNodes.has(category.id)"
        [nzHeader]="headerTemp"
      >
        <ng-container
          *ngFor="let child of category.childCategories"
          [ngTemplateOutlet]="catWrapper"
          [ngTemplateOutletContext]="{ category: child }"
        ></ng-container>
      </nz-collapse-panel>
    </nz-collapse>
  </ng-container>
  <ng-container *ngIf="category.childCategories.length == 0">
    <div class="child-category">
      <ng-container [ngTemplateOutlet]="headerTemp"></ng-container>
    </div>
  </ng-container>
  <ng-template #headerTemp>
    <nz-space>
      <label
        *nzSpaceItem
        nz-checkbox
        [nzChecked]="_selectedCategories.has(category.id)"
        (nzCheckedChange)="nodeSelectionChanged(category.id)"
      ></label>
      <span *nzSpaceItem>{{ category.name }}</span>
    </nz-space>
  </ng-template>
</ng-template>
